<template>
  <div ref="box" class="page-box">
    <div
      v-if="advertTop.status && advertTop.list.length"
      ref="top"
      class="top-list-box"
    >
      <advert-top></advert-top>
    </div>
    <div ref="panel" class="panel-box">
      <panel-box></panel-box>
    </div>
    <div ref="topTab" class="tab-list-box" :style="{ position: isFixed ? 'fixed': 'relative' }">
      <menus-tab v-model="menusActive" :showType="showType"></menus-tab>
    </div>
    <div v-if="isFixed" style="height:40px;width:100%"/>
    <div
      v-if="advertMiddle.status && advertMiddle.list.length"
      class="middle-list-box"
    >
      <advert-middle></advert-middle>
    </div>
    <div class="content-box">
      <div ref="box-list" class="menu-list-box" :style="{height: top || false ? '100%' : 'auto'}">
        <menus-list v-model="menusActive"></menus-list>
      </div>
    </div>
    <share-box></share-box>
    <business-notice></business-notice>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import loginAction from '@/utils/UserAction/login'
const advertTop = resolve =>
  require(['@/components/modules/advert/top'], resolve)
const panelBox = resolve =>
  require(['@/components/modules/panel/index'], resolve)
const advertMiddle = resolve =>
  require(['@/components/modules/advert/middle'], resolve)
const menusTab = resolve => require(['@/components/modules/menus/tab'], resolve)
const menusList = resolve =>
  require(['@/components/modules/menus/list'], resolve)
const shareBox = resolve =>
  require(['@/components/modules/share/index'], resolve)
const businessNotice = resolve => require(['@/components/common/BusinessNotice/index'], resolve);

export default {
  components: {
    advertTop,
    panelBox,
    menusTab,
    advertMiddle,
    menusList,
    shareBox,
    businessNotice
  },
  data() {
    return {
      menusActive: 0,
      topHeight: 0,
      isFixed: false,
      pageTop: false,
      retryJsBridgeTimes: 0,
    }
  },
  computed: {
    ...mapGetters({
      channelInfo: 'channelInfo',
      menuList: 'menuList',
      advertTop: 'advertTop',
      advertMiddle: 'advertMiddle'
    }),
    showType() {
      return this.menuList[this.menusActive].type || ''
    },
    top() {
      return this.channelInfo.isTop || this.pageTop
    }
  },
  watch: {
    'channelInfo.uin'() {
      this.registerH5ProvideMethods()
    }
  },
  mounted() {
    if (!this.top) {
      setInterval(() => {
        this.setHeight()
      }, 1000)
    }
    this.$Bus.$on('bus-setPageTop', this.setPageTop)
    this.$Bus.$on('bus-scrollCreate', this.scrollCreate)
    this.$Bus.$on('bus-scrollDestroyed', this.scrollDestroyed)
  },
  destroyed() {
    !this.top && window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    // JSBridge相关逻辑 v2
    registerH5ProvideMethods() {
      if (this.retryJsBridgeTimes > 20) return
      if (window._gdyJsApi) {
        window._gdyJsApi.onTokenInject(({ token } = { token: '' }) => {
          loginAction.call(this, { token })
        })
        window._gdyJsApi.onLimitedMode();
      } else {
        this.retryJsBridgeTimes++
        setTimeout(() => {
          this.registerH5ProvideMethods();
        }, 400);
      }
    },
    scrollCreate() {
      !this.top && window.addEventListener('scroll', this.onScroll)
    },
    scrollDestroyed() {
      !this.top && window.removeEventListener('scroll', this.onScroll)
    },
    setPageTop(flag) {
      this.pageTop = flag
    },
    getMore() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollHeight > clientHeight && scrollTop + clientHeight > scrollHeight - 100) {
        this.$Bus.$emit('bus-getList')
      }
    },
    setHeight() {
      const top = (this.$refs.top && this.$refs.top.clientHeight) || 0
      const panel = (this.$refs.panel && this.$refs.panel.clientHeight) || 0
      this.topHeight = top + panel
    },
    onScroll () {
      this.getMore()
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      const offsetTop = this.$refs.panel.offsetHeight + this.$refs.panel.offsetTop
      if (scrollTop > offsetTop) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
  }
}
</script>
<style lang="less" scoped>
.page-box {
  margin: auto;
  width: 100%;
  max-width: 640px;
  height: 100vh;
}
.page-box {
  display: flex;
  flex-direction: column;

  .top-list-box {
    flex: 0 0 auto;
  }
  .panel-box {
    flex: 0 0 auto;
  }
  .middle-list-box {
    flex: 0 0 auto;
  }
  .tab-list-box {
    flex: 0 0 auto;
    width: 100%;
    z-index: 1400;
  }
  .content-box {
    flex: 1;
    height: 0;
    position: relative;
    .menu-list-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      // height: 100%;
    }
  }
}
</style>
